/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { tokens, orange, inkA } from '../tokens';

// Ghost pill tab with a circular count badge and optional status dot.
function Chip({ o, on, onClick }) {
  const theme = useTheme();
  const t = tokens(theme);
  const [h, setH] = useState(false);
  const hover = h && !on;
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setH(true)}
      onMouseLeave={() => setH(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '7px 18px',
        borderRadius: 18,
        cursor: 'pointer',
        background: on
          ? orange(0.1)
          : hover
          ? inkA(theme, 0.07)
          : inkA(theme, 0.035),
        border:
          '1.5px solid ' +
          (on ? t.primary : hover ? inkA(theme, 0.28) : inkA(theme, 0.14)),
        color: on ? t.primary : hover ? inkA(theme, 0.92) : inkA(theme, 0.6),
        fontSize: 14,
        fontWeight: on ? 700 : 600,
        letterSpacing: '0.1px',
        transition: 'all 120ms ease',
      }}
    >
      {o.dot && (
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: o.dotColor,
            flexShrink: 0,
          }}
        />
      )}
      {o.label}
      {o.count != null && (
        <span
          style={{
            height: 18,
            minWidth: 18,
            padding: '0 5px',
            borderRadius: 9,
            fontSize: '11.5px',
            fontWeight: 700,
            fontVariantNumeric: 'tabular-nums',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
            boxSizing: 'border-box',
            background: on ? orange(0.18) : inkA(theme, 0.07),
            color: on ? t.primary : inkA(theme, 0.55),
          }}
        >
          {o.count}
        </span>
      )}
    </button>
  );
}

const SegmentedFilter = ({ value, onChange, options }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
    {options.map((o) => (
      <Chip
        key={o.key}
        o={o}
        on={value === o.key}
        onClick={() => onChange(o.key)}
      />
    ))}
  </div>
);

export default SegmentedFilter;
